module.exports = "https://cdn.thelire.com/ins/resource/store_vip_nav_icon.9c5c48631d4607f57eaa4d464455c351.png";